var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TopBar',{on:{"translationRequested":_vm.setLanguage,"storePreviousLanguage":_vm.setSource}}),_c('Form',{attrs:{"sourceLanguage":_vm.sourceLanguage,"targetLanguage":_vm.targetLanguage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }